"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLayerPortalNode = void 0;
var portalExists = function portalExists() {
  var portal = document.querySelector('#LayerPortalNode');
  return document.body.contains(portal);
};
var createLayerPortalNode = function createLayerPortalNode() {
  if (!portalExists()) {
    var portal = document.createElement('div');
    portal.setAttribute('id', 'LayerPortalNode');
    portal.setAttribute('data-testid', 'LayerPortalNode');
    document.body.appendChild(portal);
  }
};
exports.createLayerPortalNode = createLayerPortalNode;